export default {"src":"/_next/static/media/germany.36fb32ea.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};